import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext, grid } from '@shared/styles';

interface Props {
  label: string;
  onPress(): void;
  disabled?: boolean;
  loading?: boolean;
  icon: MBIconV2Name;
  anchorName?: string;
}

export function MBQuestionInputActionButton({
  label,
  onPress,
  disabled = false,
  loading = false,
  icon,
  anchorName,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const color = loading ? colors.foregroundInactive : colors.foregroundActive;

  return (
    <MBTouchableOpacity onPress={onPress} disabled={disabled}>
      <View row centerVertically marginHorizontal={1} style={{ anchorName }}>
        {loading ? (
          <View style={{ width: grid(4), height: grid(4) }} center>
            <MBLoadingIndicator />
          </View>
        ) : (
          <MBIconV2 name={icon} color={color} size={grid(4)} />
        )}
        <Text size="body2" weight="semibold" color={color}>
          {label}
        </Text>
      </View>
    </MBTouchableOpacity>
  );
}
